<template>
  <div v-if="state.visible" class="popup-container" :class="{ 'mobile-fix': isMobile }">
    <div class="popup-wrapper">
      <div class="gdpr-desc">
        <p v-if="tenantId === tenantMap.hikvision" class="paragraph">
          <a class="link" target="_blank" href="https://elearning.hikvision.com/">elearning.hikvision.com</a>  {{ $t('gdpr.popup.gdprTextOne') }}
        </p>
        <p v-else-if="tenantId === tenantMap.micro" class="paragraph">
          <a class="link" target="_blank" href="https://elearning.hikmicrotech.com/">elearning.hikmicrotech.com</a>  {{ $t('gdpr.popup.gdprTextOne') }}
        </p>
        <p class="paragraph">{{ $t('gdpr.popup.gdprTextTwo') }} <a class="link" target="_blank" href="/cookies-preferences">{{ $t('gdpr.popup.manageCookie') }}</a>  {{ $t('gdpr.popup.gdprTextThree') }}.</p>
        <p v-if="tenantId === tenantMap.hikvision" class="paragraph">{{ $t('gdpr.popup.gdprTextFour') }} <a class="link" target="_blank" href="https://www.hikvision.com/en/elearning/cookie-policy/">{{ $t('gdpr.popup.cookiePolicy') }}</a>.</p>
        <p v-else-if="tenantId === tenantMap.micro" class="paragraph">{{ $t('gdpr.popup.gdprTextFour') }} <a class="link" target="_blank" href="https://www.hikmicrotech.com/en/policy/cookie-policy/">{{ $t('gdpr.popup.cookiePolicy') }}</a>.</p>
      </div>
      <div class="button-area">
        <Button
          v-at-action="'cookies::accept'"
          :type="state.showReject ? type.normal : type.submit"
          :style="{
            height: isMobile ? '3.2rem' : ''
          }"
          @click="onAccept"
        >
          {{ $t('gdpr.accept') }}
        </Button>
        <Button
          v-if="state.showReject"
          v-at-action="'cookies::reject'"
          :type="type.normal"
          style="margin-left: 16px;"
          :style="{
            height: isMobile ? '3.2rem' : ''
          }"
          @click="onReject"
        >
          {{ $t('gdpr.reject') }}
        </Button>
        <Button
          v-at-navigation="'cookies::gdpr'"
          :type="type.normal"
          style="margin-left: 16px;"
          :style="{
            height: isMobile ? '3.2rem' : ''
          }"
          @click="onManage"
        >
          {{ $t('gdpr.manage') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, onMounted, computed } from 'vue'
import { Button } from '@/components/common'
// import { useRouter } from 'vue-router'
import { CookieUtil, StoreUtil, getTenantMap } from '@/utils'
import { useClientCompatibleHook } from '@/utils/hooks'
import { STRICT_COOKIE_POLICY_CONTRIES } from '@/utils/config'
import { useStoreHooks } from '@/store/hook'

export default defineComponent({
  components: {
    Button
  },
  props: {
    isoCode: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { state: _state } = useStoreHooks()
    const { isMobile, push } = useClientCompatibleHook()
    const state = reactive({
      visible: false,
      showReject: false
    })
    const onUserClick = () => {
      CookieUtil.updateCookieDisclaimer()
      state.visible = false
    }
    const isEu = computed(() => _state.global.isEU)
    onMounted(() => {
      const { isoCode } = props
      const cookieViewed = CookieUtil.getCookie(CookieUtil.ELEARNING_COOKIE.cookieDisclaimer) !== CookieUtil.COOKIE_STATUS.true
      if (cookieViewed) {
        state.visible = true
        // 如果是uk站或者是立陶宛、爱沙尼亚、拉脱维亚的用户访问时，要展示rejectAll
        state.showReject = isEu.value || STRICT_COOKIE_POLICY_CONTRIES.includes(isoCode)
      }
    })
    return {
      state,
      type: Button.TYPE,
      isMobile,
      onAccept () {
        // todo
        onUserClick()
        StoreUtil.acceptAllPolicy()
      },
      onReject () {
        // todo
        onUserClick()
        CookieUtil.deleteAllCookie()
        StoreUtil.rejectAllPolicy()
      },
      onManage () {
        onUserClick()
        push('/cookies-preferences')
      },
      tenantId: computed(() => _state.global.tenantId),
      tenantMap: getTenantMap()
    }
  }
})
</script>

<style lang="less" scoped>
.popup-container {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  height: auto;
  padding: 30px 0;
  background: #FFFFFF;
  box-shadow: 0px -7px 16px 0px rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  .popup-wrapper {
    .flex--box--space--between();
    .body--container();
    .gdpr-desc {
      flex-basis: 1020px;
      margin-right: 40px;
      font-size: 14px;
      color: #333333;
      line-height: 24px;
      .paragraph {
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .link {
        color: #007AFF;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .button-area {
      display: flex;
      align-items: center;
    }
  }
}
// 移动端样式
.popup-container.mobile-fix {
  padding: 1.6rem 1.5rem;
  height: auto;
  .popup-wrapper {
    display: block;
    width: 100%;
    padding: 0;
    .gdpr-desc {
      width: 100%;
      font-size: 1.3rem;
      margin-bottom: 1.2rem;
    }
    .button-area {
      justify-content: center;
      width: 100%;
      :deep(.mobile-button) {
        padding: 0.8rem 1.2rem !important;
        height: auto !important;
        border-radius: 10rem !important; //不是固定搞定，radius写大一些
        white-space: break-spaces;
      }
    }
    .paragraph {
      margin-bottom: 0;
    }
  }
}

</style>
